import {createContext} from "react";

type TabContextType = {
    withForm?: boolean;
};

export const TableContext = createContext<TabContextType>({});
